import React from "react";
import { Facebook, Instagram, Mail, MapPin, MessageSquareText, Phone, Star } from "lucide-react";
import { Link } from "wouter";
import { serviceStates } from "@/data/serviceAreas";
import { assets, materials, siteConfig } from "@/data/site";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        <div className="site-footer__brand">
          <Link href="/" aria-label="Partition Stalls home">
            <img src={assets.footerLogo} alt="Partition Stalls" width="489" height="182" loading="lazy" />
          </Link>
          <p>{siteConfig.description}</p>
          <address className="footer-contact">
            <a href={`tel:${siteConfig.phoneHref}`}><Phone aria-hidden="true" /> {siteConfig.phoneDisplay}</a>
            <a href={`mailto:${siteConfig.email}`}><Mail aria-hidden="true" /> {siteConfig.email}</a>
            <a href={siteConfig.address.googleBusinessProfile} target="_blank" rel="noopener noreferrer" aria-label={`Open Partition Stalls at ${siteConfig.address.display} in Google Maps`}><MapPin aria-hidden="true" /> {siteConfig.address.display}</a>
          </address>
          <nav className="footer-reviews" aria-label="Partition Stalls Google reviews">
            <a href={siteConfig.googleReviews.read} target="_blank" rel="noopener noreferrer" aria-label="Read Google Reviews for Partition Stalls (opens in a new tab)"><MessageSquareText aria-hidden="true" /><span>Read Google Reviews</span></a>
            <a href={siteConfig.googleReviews.leave} target="_blank" rel="noopener noreferrer" aria-label="Leave a Google Review for Partition Stalls (opens in a new tab)"><Star aria-hidden="true" /><span>Leave a Google Review</span></a>
          </nav>
          <nav className="footer-social" aria-label="Partition Stalls social profiles">
            <a href={siteConfig.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Partition Stalls on Facebook">
              <Facebook aria-hidden="true" /> <span>Facebook</span>
            </a>
            <a href={siteConfig.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Partition Stalls on Instagram">
              <Instagram aria-hidden="true" /> <span>Instagram</span>
            </a>
          </nav>
        </div>
        <div>
          <h3>Partition materials</h3>
          <ul>
            {materials.map((material) => (
              <li key={material.slug}><Link href={`/bathroom-partitions/${material.slug}`}>{material.name}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h3>Buyer resources</h3>
          <ul>
            <li><Link href="/resources">Resource library</Link></li>
            <li><Link href="/resources/buyer-guides">Buyer guides</Link></li>
            <li><Link href="/resources/mounting-styles">Mounting styles</Link></li>
            <li><Link href="/resources/privacy-options">Privacy options</Link></li>
            <li><Link href="/resources/how-to-measure">How to measure</Link></li>
            <li><Link href="/resources/colors-finishes">Colors & finishes</Link></li>
            <li><Link href="/resources/faqs">Project FAQs</Link></li>
            <li><Link href="/technical-resources">Technical resources</Link></li>
          </ul>
        </div>
        <div>
          <h3>Company & contact</h3>
          <ul>
            <li><Link href="/why-partition-stalls">Why Partition Stalls</Link></li>
            <li><Link href="/projects">Documented projects</Link></li>
            <li><Link href="/contact-partition-stalls">Contact us</Link></li>
            <li><Link href="/commercial-restroom-accessories">Accessories catalog</Link></li>
            <li><Link href="/accessory-quote-cart">Accessory Quote List</Link></li>
            <li><Link href="/sub-assemblies">Sub-assembly guides</Link></li>
            <li><Link href="/bathroom-partitions">Compare materials</Link></li>
            <li><Link href="/partition-budget-calculator">Partition budget calculator</Link></li>
            <li><Link href="/request-a-quote">Request a quote</Link></li>
          </ul>
        </div>
        <div>
          <h3>Service areas</h3>
          <ul className="service-area-list">
            {serviceStates.map((state) => <li key={state.abbreviation}><Link href={`/service-areas/${state.slug}`}>{state.name}</Link></li>)}
            <li><Link href="/service-areas">Nationwide material supply</Link></li>
          </ul>
        </div>
      </div>
      <div className="site-footer__legal">
        <p>© {new Date().getFullYear()} Partition Stalls. Commercial restroom solutions supplied nationwide.</p>
        <nav aria-label="Legal information">
          <Link href="/privacy-policy">Privacy Policy</Link>
          <Link href="/terms-of-use">Terms of Use</Link>
        </nav>
      </div>
    </footer>
  );
}
